import { ListItem, Checkbox, Typography, Grid, FormControlLabel } from 'components/ui';

const ExecuteItem = ({ index, processing, obj, setFieldValue }) => {
  return (
    <ListItem disableGutters>
      <Grid container justifyContent="space-between" alignItems="center" className="full-width">
        <FormControlLabel control={
          <Checkbox
            margin="dense"
            disabled={processing}
            name={`inspectionFields[${index}].value`}
            checked={obj.value === true}
            onChange={(_event, value) => {
              setFieldValue(`inspectionFields[${index}].value`, value);
            }}
            />}
          label={<Typography>{obj.name}</Typography>} />
      </Grid>
    </ListItem>
  );
};

export default ExecuteItem;
